module.exports = __webpack_public_path__ + "8e399f09dee305dcb472d68bf82d1573.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/13_C3.mp3
// module id = 71
// module chunks = 0